import React from "react";
import { Icon } from "../../../core/Icon";
export const ForgottenPasswordSent = () => {
    return (React.createElement("div", { className: "process-master-challenge text-center" },
        React.createElement("div", null,
            React.createElement(Icon, { c: ['tick-circle', 64, 64, 'success-icon'] }),
            React.createElement("h1", { className: "mb-8" }, "Zapomenut\u00E9 heslo"),
            React.createElement("p", null,
                "Instrukce k vyresetov\u00E1n\u00ED hesla byly odesl\u00E1ny na uveden\u00FD email. ",
                React.createElement("br", null),
                "Zav\u0159ete toto okno a pokra\u010Dujte pomoc\u00ED odkazu v emailu."))));
};
